import React from 'react';

const Result = () => {
  return (
    <div class="relative bg-yellow bg-opacity-15 py-16">
      <div class="relative max-w-5xl mx-auto">
        <h2 class="tracking-wide font-extrabold text-green-400 text-5xl">Congratulations!</h2>
        <p class="mx-auto text-black sm:text-lg md:text-2xl">
          You’re not require to pay a deposit, you only need to pay a 5% deposit, you only have to
          pay a 20% deposit.
        </p>
      </div>
      <div class="mt-16 max-w-5xl mx-auto">
        <h2 class="tracking-wide font-extrabold text-gray-600 text-5xl">
          Enroll in Autopay / Pay Deposit
        </h2>
        <p class="text-black sm:text-lg md:text-2xl">
          If you enroll in Autopay now, we will withdraw your deposit immediately if applicable,
          otherwise it will take affect as of your next billing cycle.
        </p>
        <div class="mt-14">
          <span class="rounded-md shadow-sm">
            <button
              type="button"
              class="inline-flex items-center px-7 pt-6 pb-5 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-black hover:bg-opacity-75 focus:outline-none focus:border-black focus:shadow-outline-black active:bg-black transition ease-in-out duration-150"
            >
              <div class="">
                {' '}
                <h3 class="text-xl font-medium"> ENROLL/PAY NOW</h3>
              </div>

              <svg
                class="ml-5 h-9 w-9"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M24 12c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12zm-18.005-1.568l1.415-1.414 4.59 4.574 4.579-4.574 1.416 1.414-5.995 5.988-6.005-5.988z" />
              </svg>
            </button>
          </span>
          <span class="ml-8 rounded-md shadow-sm">
            <button
              type="button"
              class="inline-flex items-center px-7 pt-6 pb-5 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-600 hover:bg-opacity-75 focus:outline-none focus:border-black focus:shadow-outline-black active:bg-black transition ease-in-out duration-150"
            >
              <div class="">
                {' '}
                <h3 class="text-xl font-medium"> ENROLL/PAY LATER</h3>
              </div>

              <svg
                class="ml-5 h-9 w-9"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M15.91 13.34l2.636-4.026-.454-.406-3.673 3.099c-.675-.138-1.402.068-1.894.618-.736.823-.665 2.088.159 2.824.824.736 2.088.665 2.824-.159.492-.55.615-1.295.402-1.95zm-3.91-10.646v-2.694h4v2.694c-1.439-.243-2.592-.238-4 0zm8.851 2.064l1.407-1.407 1.414 1.414-1.321 1.321c-.462-.484-.964-.927-1.5-1.328zm-18.851 4.242h8v2h-8v-2zm-2 4h8v2h-8v-2zm3 4h7v2h-7v-2zm21-3c0 5.523-4.477 10-10 10-2.79 0-5.3-1.155-7.111-3h3.28c1.138.631 2.439 1 3.831 1 4.411 0 8-3.589 8-8s-3.589-8-8-8c-1.392 0-2.693.369-3.831 1h-3.28c1.811-1.845 4.321-3 7.111-3 5.523 0 10 4.477 10 10z" />
              </svg>
            </button>
          </span>
          <div class="mt-14 border border-solid border-black"></div>
        </div>
        <div class="mt-14 flex">
          <fieldset class=" sm:col-span-2">
            <legend class="block text-sm font-bold leading-5 text-gray-700">
              Select Payment Method
            </legend>
            <div class="mt-4 grid grid-cols-1 gap-y-4">
              <div class="flex items-center">
                <input
                  id="budget_under_25k"
                  name="budget"
                  value="under_25k"
                  type="radio"
                  class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  placeholder="sample"
                />
                <div for="budget_under_25k" class="ml-3">
                  <span class="block text-sm leading-5 text-gray-700">Credit/Debit Card</span>
                </div>
              </div>
              <div class="flex items-center">
                <input
                  id="budget_25k-50k"
                  name="budget"
                  value="25k-50k"
                  type="radio"
                  class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  placeholder="sample"
                />
                <div for="budget_25k-50k" class="ml-3">
                  <span class="block text-sm leading-5 text-gray-700">Bank Account</span>
                </div>
              </div>
            </div>
          </fieldset>

          <p class="mr-2 pl-6 max-w-4xl mx-auto text-left">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel dignissim magna, a
            lobortis risus. Donec ac sagittis ipsum, a pulvinar felis. Nunc ut pulvinar enim.
            Aliquam erat volutpat. Aenean ut congue diam, eu dignissim dui.{' '}
          </p>
        </div>
        <div class="pt-8 max-w-5xl">
          <form
            action="#"
            method="POST"
            class="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-8"
          >
            <div class="sm:col-span-2">
              <div for="first_name" class="block text-sm font-bold leading-5 text-gray-700">
                Card Type
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="first_name"
                  placeholder="Auto Loaded Based On Number"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>

            <div class="sm:col-span-2">
              <div for="email" class="block text-sm font-bold leading-5 text-gray-700">
                Card Number
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  placeholder="5555-5555-5555"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>
            <div class="sm:col-span-2">
              <div for="service-address" class="block text-sm font-bold leading-5 text-gray-700">
                Billing Address*
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="service-address*"
                  placeholder="1234 Happy Lane Suite A"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>
            <div>
              <div for="city" class="block text-sm font-bold leading-5 text-gray-700">
                City
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="city"
                  placeholder="Tampa"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>
            <div>
              <div for="zip" class=" block text-sm font-bold leading-5 text-gray-700">
                Zip
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="zip"
                  placeholder="333333"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>

            <div>
              <div for="zip" class="block text-sm font-bold leading-5 text-gray-700">
                Expiration Date
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="zip"
                  placeholder="MM/YY"
                  type="number"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>
            <div>
              <div for="zip" class="block text-sm font-bold leading-5 text-gray-700">
                CVV
              </div>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="zip"
                  placeholder="333"
                  type="number"
                  class="py-4 form-input block w-full transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                ></input>
              </div>
            </div>

            <div class="sm:col-span-2">
              <div class="mt-8 flex items-center">
                <input
                  id="remember_me_a"
                  type="checkbox"
                  required
                  class="mr-4 form-checkbox h-8 w-8 text-black transition duration-150 ease-in-out"
                />
                <div for="remember_me" class="ml-2 block text-xs text-black">
                  <p>My service and billing address are the same</p>
                </div>
              </div>
            </div>

            <div class="">
              <span class="rounded-md">
                <button
                  type="submit"
                  class="inline-flex justify-center py-4 px-10 border border-black border-2 text-sm leading-5 font-bold rounded-md text-black bg-transparent hover:bg-black hover:text-white focus:outline-none focus:border-white focus:shadow-outline-black active:bg-black transition duration-150 ease-in-out"
                >
                  Next
                  <svg
                    class="ml-3 -mr-1 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M24 12c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12zm-18.005-1.568l1.415-1.414 4.59 4.574 4.579-4.574 1.416 1.414-5.995 5.988-6.005-5.988z" />
                  </svg>
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Result;
